<template>
  <v-toolbar flat color="transparent">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="registrarResponsable">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ResponsablesToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    registrarResponsable() {
      this.$emit('registrarResponsable');
    },
  },
};
</script>

<style lang="scss">

</style>
